'use strict';

var tslib_es6 = require('./tslib.es6-130a177d.js');
var React = require('react');
var Icons_PlusIcon_index = require('./Icons/PlusIcon/index.js');
var Icons_MinusIcon_index = require('./Icons/MinusIcon/index.js');
var styled = require('styled-components');
var typography_index = require('./typography/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var StyledTabHeader = styled__default['default'].button.withConfig({ displayName: "ww-uikit_StyledTabHeader_locmlpb7", componentId: "sc-wbnx38" })(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    min-height: 52px;\n    display: flex;\n    width: 100%;\n    cursor: pointer;\n    justify-content: space-between;\n    align-items: center;\n    user-select: none;\n    text-align: left;\n    :focus-visible {\n        outline: currentColor 1px solid;\n        outline-offset: 2px;\n    }\n"], ["\n    min-height: 52px;\n    display: flex;\n    width: 100%;\n    cursor: pointer;\n    justify-content: space-between;\n    align-items: center;\n    user-select: none;\n    text-align: left;\n    :focus-visible {\n        outline: currentColor 1px solid;\n        outline-offset: 2px;\n    }\n"])));
var StyledWrapper = styled__default['default'].div.withConfig({ displayName: "ww-uikit_StyledWrapper_locmlpb8", componentId: "sc-1mlie2a" })(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    border-top: 1px solid ", ";\n"], ["\n    border-top: 1px solid ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.charcoal20;
});
var StyledTitle = styled__default['default'].h2.withConfig({ displayName: "ww-uikit_StyledTitle_locmlpb8", componentId: "sc-1dpc72w" })(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n    ", "\n    color: ", ";\n"], ["\n    ", "\n    color: ", ";\n"])), typography_index.body1, function (_a) {
    var theme = _a.theme;
    return theme.colors.charcoal100;
});
var StyledContent = styled__default['default'].div.withConfig({ displayName: "ww-uikit_StyledContent_locmlpb8", componentId: "sc-1ag53uq" })(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n    overflow: hidden;\n    transition: height 0.2s linear 0s;\n    height: auto;\n    display: block;\n"], ["\n    overflow: hidden;\n    transition: height 0.2s linear 0s;\n    height: auto;\n    display: block;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

var AccordionMenu = function (_a) {
    var _b = _a.isTabOpened, isTabOpened = _b === void 0 ? false : _b, children = _a.children, clickHandler = _a.clickHandler, renderTitle = _a.renderTitle, testId = _a.testId, className = _a.className, id = _a.id;
    var _c = React.useState(isTabOpened), isOpened = _c[0], setIsOpened = _c[1];
    var panelId = id ? id + "_panel" : undefined;
    var tabId = id ? id + "_tab" : undefined;
    var handleOnClick = function () {
        setIsOpened(!isOpened);
        if (clickHandler) {
            clickHandler();
        }
    };
    React.useEffect(function () {
        setIsOpened(isTabOpened);
    }, [isTabOpened]);
    var additionalProps = {};
    if (testId) {
        additionalProps['data-testid'] = testId;
    }
    return (React__default['default'].createElement(StyledWrapper, tslib_es6.__assign({ className: className }, additionalProps),
        React__default['default'].createElement(StyledTabHeader, { onClick: handleOnClick, id: tabId, "aria-controls": panelId, "aria-expanded": isOpened, "data-testid": "accordion_btn" },
            React__default['default'].createElement(StyledTitle, null, renderTitle()),
            !isOpened ? React__default['default'].createElement(Icons_PlusIcon_index['default'], null) : React__default['default'].createElement(Icons_MinusIcon_index['default'], { as: "div" })),
        isOpened && (React__default['default'].createElement(StyledContent, { id: panelId, "aria-labelledby": tabId, role: "region", "data-testid": "accordion_content" }, children))));
};

exports.AccordionMenu = AccordionMenu;
//# sourceMappingURL=Accordion-c861026d.js.map
